import React from 'react';

export default ({ children }) =>
  <div className="loader">
    <div className="spinner" title={children} />
  </div>
